<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
		<g id="Group_47385" data-name="Group 47385" transform="translate(1 0.5)">
			<g id="Group_21841" data-name="Group 21841">
				<g id="Group_21740" data-name="Group 21740">
					<g id="Rectangle_7517" data-name="Rectangle 7517" transform="translate(0 0.5)" fill="#fff" stroke="#d6ddea" stroke-width="1">
						<rect width="35" height="35" rx="8" stroke="none" />
						<rect x="-0.5" y="-0.5" width="36" height="36" rx="8.5" fill="none" />
					</g>
					<g id="Group_47386" data-name="Group 47386" transform="translate(-2 -2.5)">
						<g id="Group_21741" data-name="Group 21741" transform="translate(12 9)">
							<g id="Group_20186" data-name="Group 20186">
								<g id="Group_8569" data-name="Group 8569">
									<g id="Group_8564" data-name="Group 8564">
										<path
											id="Path_1125"
											data-name="Path 1125"
											d="M567.657,1222.441a2.643,2.643,0,0,1-2.64-2.64,2.474,2.474,0,0,1,.837-1.9l1.8-1.8,1.8,1.8a2.475,2.475,0,0,1,.837,1.9A2.641,2.641,0,0,1,567.657,1222.441Zm0-5.075-1.168,1.166a1.61,1.61,0,0,0-.574,1.269,1.741,1.741,0,1,0,3.482.006v-.006a1.6,1.6,0,0,0-.574-1.269Z"
											transform="translate(-554.537 -1206.556)"
											fill="#515a6f"
										/>
										<path
											id="Path_1126"
											data-name="Path 1126"
											d="M561.366,1221.844a.779.779,0,0,1-.388-.1l-6.052-3.495a.78.78,0,0,1-.285-1.064l4.853-8.407,8.129,4.694a.694.694,0,0,1-.322,1.295,2.54,2.54,0,0,0-2.132,1.276l-3.127,5.417A.785.785,0,0,1,561.366,1221.844Zm-5.886-4.318,5.844,3.374,3.06-5.3a3.442,3.442,0,0,1,2.26-1.659L559.822,1210Z"
											transform="translate(-554.537 -1206.556)"
											fill="#515a6f"
										/>
										<path
											id="Path_1127"
											data-name="Path 1127"
											d="M562.337,1213.778h-.9v-4.7a1.624,1.624,0,0,0-3.248,0v3.634h-.9v-3.634a2.522,2.522,0,0,1,5.044,0Z"
											transform="translate(-554.537 -1206.556)"
											fill="#515a6f"
										/>
										<circle
											id="Ellipse_108"
											data-name="Ellipse 108"
											cx="0.782"
											cy="0.782"
											r="0.782"
											transform="translate(6.569 6.44)"
											fill="#515a6f"
										/>
									</g>
								</g>
							</g>
						</g>
						<rect
							id="Rectangle_15024"
							data-name="Rectangle 15024"
							width="14.755"
							height="3"
							rx="0.5"
							transform="translate(12.5 27.754)"
							:fill="color"
							stroke="#515a6f"
							stroke-width="1"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>
<script>
export default { name: 'NotificationColorPickerSVG', props: { color: { type: String, default: '#5a6ee2' } } };
</script>
